import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { cardReveal, fadeUp, ParallaxImage, Reveal, staggerContainer, viewportOnce } from "../common/Motion";

const values = [
  ["Start with the decision", "We find where intelligence can improve a real choice, experience, or operational outcome."],
  ["Engineer for trust", "Security, evaluation, explainability, and human oversight shape every AI system from day one."],
  ["Learn in production", "We measure quality and business impact so models, workflows, and teams improve together."],
];

const DiscoverCompany = () => {
  const reduceMotion = useReducedMotion();
  return (
  <section id="about-us" className="section about-section">
    <div className="site-shell">
      <Reveal className="section-heading split-heading">
        <div><p className="eyebrow">How we think</p><h2>AI-first. Human-centered. Built for reality.</h2></div>
        <p>We are an AI-first technology company. Strategists, engineers, and data specialists work as one team to turn business knowledge into useful intelligence—then embed it inside dependable products and workflows.</p>
      </Reveal>
      <motion.div className="value-grid" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
        {values.map(([title, copy], index) => <motion.article variants={cardReveal} whileHover={reduceMotion ? undefined : { y: -6 }} className="value-card" key={title}><span>0{index + 1}</span><h3>{title}</h3><p>{copy}</p></motion.article>)}
      </motion.div>
      <motion.figure className="about-visual" variants={reduceMotion ? undefined : fadeUp} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
        <ParallaxImage src="/about-team.png" alt="Collaborative AI workspace connecting people, data, and intelligent systems" />
      </motion.figure>
    </div>
  </section>
  );
};
export default DiscoverCompany;
